import { Validation, ValueObject } from '@singularsystems/neo-core';
import DividendBaseCriteria from '../../../../../Reporting/Reports/Dividends/DividendBaseCriteria';

export default class LadderProjectionDividendCriteria extends ValueObject {

    constructor(
        dividendCriteria: DividendBaseCriteria,
        isAsset: boolean) {
        super();
        this.makeObservable();
        this.dividendCriteria = dividendCriteria;
        this.isAsset = isAsset;
    }

    public dividendCriteria: DividendBaseCriteria | null = null;
    public isAsset: boolean = false;

    // Client only properties / methods

    protected static addBusinessRules(rules: Validation.Rules<LadderProjectionDividendCriteria>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        return "Ladder Projection Dividend Criteria";
    }
}